import { Route } from '@angular/router';
import { DonationsListComponent } from './donations-list.component';
import { AuthGuard } from '../../../shared/services';
import { AssociationsForFilterResolver } from '../../associations/associations-for-filter/associations-for-filter.resolver';
// import { DonationsListResolver } from './donations-list.resolver';

export const DonationsListRoutes: Route[] = [
    {
      path: 'list/:type',
      component: DonationsListComponent,
      canActivate: [AuthGuard],
       resolve: {
         assocsForFilter: AssociationsForFilterResolver
       }
    }
  ];
